import React from 'react';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";
import Select from "../../form/Select";

class ProductCategoryForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-md-2">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />
                    </div>
                    <div className="col-md-10">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="name"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Név"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-6">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="vat"
                            storeType="local"
                            objectValue={true}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Áfa érték"
                        />
                    </div>
                    <div className="col-md-6">
                        <Select
                            {...this.props.getFieldProps("product_type")}
                            componentConfig={this.props.componentConfig}
                            name="product_type"
                            storeType="local"
                            valueKey="id"
                            labelKey="label"
                            options={[
                                {id: "PROD", label: "Termék"},
                                {id: "VIRT", label: "Virtuális termék"},
                                {id: "SERV", label: "Szolgáltatás"},
                            ]}
                            objectValue={false}
                            value={this.props.values.product_type}
                            setFieldValue={this.props.setFieldValue}
                            label="Típus"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-6">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="token"
                            storeType="local"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Token"
                        />
                    </div>
                    <div className="col-md-6">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="unit"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Mértékegység"
                        />
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(ProductCategoryForm);
